<template>
  <div>
<!--    <v-container>-->
      <v-layout row wrap>
        <v-flex xs12 md8 lg8>
        </v-flex>
        <v-flex xs12 md4 lg4 class="text-xs-right">
          <v-btn @click="storeDialog = true" color="primary">
            Edit
          </v-btn>
        </v-flex>


      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md12 lg8>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md6 mt-3>
                  <b>Train Number</b>
                  <br>
                  {{ details.number }}
                </v-flex>
                <v-flex xs12 md6 mt-3>
                  <b>Name</b>
                  <br>
                  {{ details.name }} ({{ details.speed }})
                </v-flex>
                <v-flex xs12 md6 mt-3>
                  <b>First Station</b>
                  <br>
                  {{ details.first_station_name }}
                </v-flex>
                <v-flex xs12 md6 mt-3>
                  <b>Last Station</b>
                  <br>
                  {{ details.last_station_name }}
                </v-flex>
                <v-flex xs12 md6 mt-3>
                  <b>Line</b>
                  <br>
                  {{ details.line_name }}
                </v-flex>
                <v-flex xs12 md6 mt-3>
                  <b>GPS Status</b>
                  <br>
                  <gps-status :status="details.gps_enabled"></gps-status>
                </v-flex>
                <v-flex xs12 md6 mt-3>
                  <b>Last Updated At</b>
                  <br>
                  {{ details.updated_at | appDateTimeFormat }}
                </v-flex>
                <v-flex xs12 md6 mt-3>
                  <b>Properties</b>
                  <br>
                  <v-chip :key="property.id" v-for="property in details.properties">{{ property.name }}</v-chip>
                  <span v-if="!details.properties.length">-</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md12 lg4>
          <v-card>
            <v-card-title>
              <span class="headline">Schedule</span>
            </v-card-title>
            <v-card-text style="max-height: 500px; overflow-y: auto;">
              <v-timeline dense>
                <v-timeline-item
                    small
                    :color="index === 0 ? 'green' : index === (details.train_schedules_by_order.length - 1) ? 'red' : 'primary'"
                    v-for="(schedule, index) in details.train_schedules_by_order"
                    :key="schedule.id"
                >
                  <v-layout py-2>
                    <v-flex>
                      <strong>{{ schedule.station_name }}</strong>
                      <div class="caption">Platform {{ schedule.platform_number }}</div>
                    </v-flex>
                    <v-flex xs3>
                      <strong>{{ schedule.time }}, {{ schedule.platform_direction }}</strong>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn icon @click="updateSchedule(schedule)">
                        <v-icon color="primary">edit</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>



      <v-dialog v-model="scheduleDialog" width="600">
        <v-card>
          <v-card-title>
            <span class="headline" v-if="this.updatingSchedule.id">
              Schedule Update
            </span>
            <span v-else>
              Schedule Add
            </span>
          </v-card-title>
          <v-card-text>
            <schedule-form :schedule-data="updatingSchedule" :key="updatingSchedule.id"
                           @success="getDetails"
            ></schedule-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar
          :timeout="snack_bar.timeout"
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>

    <v-dialog v-model="storeDialog" max-width="1000">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          <span>Update Local Train</span>
          <v-btn icon @click="storeDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <train-form :train-number="details.number" v-if="storeDialog" @success="getDetails"></train-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import GpsStatus from "../Common/GpsStatus";
import ScheduleForm from "./ScheduleForm";
import TrainForm from "./TrainForm";

export default {
  created() {
  },
  components: {GpsStatus, TrainForm, ScheduleForm, },
  computed: {},
  watch: {},
  methods: {
    updateSchedule(schedule) {
      this.updatingSchedule = schedule
      this.scheduleDialog = true
    },
    getDetails() {
      this.scheduleDialog = false
      this.storeDialog = false
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/local-trains/`+this.$route.params.id+`/details`,{headers:
                this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.details = response.data.data;
            }
          })
          .catch(() => {
            // console.log(error);
            this.snack_bar.message = "Error Occurred";
            this.snack_bar.show = true;
          })
          .finally(() => {
            {
              this.loaders.train_list = false;
            }
          });
    }
  },
  data: () => {
    return {
      storeDialog: false,
      scheduleDialog: false,
      updatingSchedule: {},
      snack_bar: {
        message: '',
        show: false
      },
      details: {
        properties: [],
        train_schedules_by_order: [],
      },
      loaders: {
        details: false
      },
      auth_user: {
        roles: [{}],
      },
    };
  },
  mounted() {
    this.getDetails()
    this.auth_user = this.$store.getters.get_user;
    // console.log(this.auth_user)
  },
};
</script>

